import React, { Component } from "react";
import { Breadcrumb, BreadcrumbItem, Card, CardBody, Button } from "reactstrap";
import { Link } from "react-router-dom";
//import CreateAgentInvoiceForm from "../../components/CreateAgentInvoiceForm";
import ListAgents from "../../components/listAgents";
import { AgentService } from "../../services";

class Agent extends Component {
  constructor(props) {
    super(props);
    this.agentService = new AgentService();
  }

  state = {
   // createUserModal: false,
    data: [],
    canNotAddMoreUser: true
  };

  componentDidMount() {
    this.getUsers();
    
    //this.getAgentList();
  }

  getUsers = async () => {
    try {
      let { data } = await this.agentService.getAgentList();
      console.log("Get Agent list Data 4",data);
      this.setState({ data:data["response"][0], canNotAddMoreUser: (data["response"][0]).length > 2  });
     
    } catch (error) {
      this.setState({ data: [] });
    }
  };

  render() {
    return (
      <div>
        <Breadcrumb style={{ marginTop: "1%" }}>
          <BreadcrumbItem>
            <Link to="/dashboard">Dashbarod</Link>
          </BreadcrumbItem>

          <BreadcrumbItem active>Agent list</BreadcrumbItem>
        </Breadcrumb>

        <div className="mt-3">
          <ListAgents data={this.state.data}  getUsers={this.getUsers}/>
        </div>

       
      </div>
    );
  }
}

export default Agent;
